//TODO: https://uberall.atlassian.net/browse/REP-5098
/* istanbul ignore file -- @preserve */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@uberall/zenit';

import './fonts.css';
import './main.css';

import { AppRoutes } from './AppRoutes.tsx';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60 * 60 * 1000,
            gcTime: (60 + 5) * 60 * 1000,
        },
    },
});
ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                <BrowserRouter basename={import.meta.env.VITE_BASE_PATH || ''}>
                    <AppRoutes />
                </BrowserRouter>
            </ThemeProvider>
        </QueryClientProvider>
    </React.StrictMode>
);
